import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useFetch } from "@/hooks/useFetch";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { fmtRp } from "@/lib/constants";

export function ApprovalTiersCard() {
  const { user } = useAuth();
  const { data, refetch } = useFetch("/settings/approval-tiers");
  const [f, setF] = useState({ manager: 0, coo: 5000000, ceo: 25000000 });
  useEffect(() => { if (data) setF(data); }, [data]);
  const save = async () => {
    try { await api.put("/settings/approval-tiers", f); toast.success("Ambang approval disimpan — berlaku untuk request baru"); refetch(); } catch (e) { toast.error(errMsg(e)); }
  };
  const F = ({ k, l, hint }) => <div><Label className="data-label">{l}</Label><Input type="number" min="0" value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value === "" ? "" : Number(e.target.value) })} className="mt-1 font-mono" disabled={user.role !== "super_admin"} data-testid={`tier-${k}`} /><p className="mt-0.5 text-[11px] text-muted-foreground">{hint}</p></div>;
  return (
    <section className="op-card p-4" data-testid="approval-tiers-card">
      <div className="mb-3 flex items-center justify-between"><h2 className="flex items-center gap-2 text-base font-semibold md:text-lg"><ShieldCheck className="h-5 w-5 text-primary" />Ambang Approval Biaya</h2>{user.role === "super_admin" && <Button size="sm" onClick={save} data-testid="tiers-save-btn">Simpan</Button>}</div>
      <p className="mb-3 text-xs text-muted-foreground">Rantai: Supervisor (check pengajuan) → Manager → COO → CEO. Ticket masuk ke tahap berikutnya bila biaya melebihi ambang. Perubahan hanya berlaku untuk request baru / revisi.</p>
      <div className="grid gap-3 sm:grid-cols-3">
        <F k="manager" l="Ambang Manager (Rp)" hint={`Biaya > ${fmtRp(f.manager || 0)} perlu approval Manager (0 = semua biaya > 0)`} />
        <F k="coo" l="Ambang COO (Rp)" hint={`Biaya > ${fmtRp(f.coo || 0)} lanjut ke COO`} />
        <F k="ceo" l="Ambang CEO (Rp)" hint={`Biaya > ${fmtRp(f.ceo || 0)} lanjut ke CEO`} />
      </div>
    </section>
  );
}

export function CatalogImportHint() {
  const dl = () => {
    const csv = "code,kind,name,category,unit,last_price,vendor_name,spec\n,ATK,Kertas A4 80gsm,Kertas,rim,55000,Toko ABC,Sinar Dunia\n,Aset,Laptop 14 inch,Komputer,unit,9500000,PT XYZ,Core i5 16GB";
    const a = document.createElement("a"); a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" })); a.download = "template_katalog_barang.csv"; a.click();
  };
  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-2 rounded-md border border-dashed p-3 text-xs" data-testid="catalog-import-hint">
      <span>Impor Excel: kolom <code className="font-mono">kind</code> (ATK/Perlengkapan/Aset), <code className="font-mono">name</code>, <code className="font-mono">category</code>, <code className="font-mono">unit</code>, <code className="font-mono">last_price</code>, <code className="font-mono">vendor_name</code>, <code className="font-mono">spec</code>. Kode ITM-xxxx dibuat otomatis jika kosong. Baris dengan nama yang sudah ada akan dilewati.</span>
      <Button size="sm" variant="outline" onClick={dl} data-testid="catalog-template-btn"><Download className="mr-1 h-4 w-4" />Template (CSV → simpan sebagai .xlsx)</Button>
    </div>
  );
}
